import { useCallback, useEffect, useState } from 'react';

import { LessonType } from '@sayyesschool/common/entities/lesson';
import datetime from '@sayyesschool/common/libs/datetime';
import LessonPillGroup from '@sayyesschool/frontend/components/lesson-pill-group';
import UserSelect from '@sayyesschool/frontend/components/user-select';
import { scheduleLessons } from '@sayyesschool/frontend/features/enrollments';
import { getNearestDay } from '@sayyesschool/frontend/features/enrollments';
import { lessonLocationsOptions, lessonTypeOptions } from '@sayyesschool/frontend/features/lessons';
import { useTeachers } from '@sayyesschool/frontend/features/teachers';
import { useFormData } from '@sayyesschool/frontend/hooks/form';
import { Form, Text } from '@sayyesschool/frontend/ui-components';

export default function LessonsForm({ enrollment, onSubmit, ...props }) {
    const [teachers] = useTeachers();

    const [lessons, setLessons] = useState([]);

    const { data, handleChange } = useFormData({
        quantity: 1,
        startDate: getNearestDay(enrollment.schedule),
        type: LessonType.Online,
        duration: enrollment.lessonDuration,
        teacher: enrollment.teacher?.id
    });

    useEffect(() => {
        const lessons = scheduleLessons({
            schedule: enrollment.schedule,
            startDate: data.startDate,
            quantity: data.quantity,
            duration: data.duration,
            teacher: data.teacher,
            location: data.location,
            type: data.type
        });

        setLessons(lessons);
    }, [enrollment, data]);

    const handleSubmit = useCallback(() => {
        onSubmit(lessons);
    }, [lessons, onSubmit]);

    return (
        <Form
            className="LessonsForm"
            onSubmit={handleSubmit}
            {...props}
        >
            <Text>{enrollment.scheduleLabel}</Text>

            <Form.Input
                label="Начальная дата"
                type="date"
                name="startDate"
                value={datetime(data.startDate).format('YYYY-MM-DD')}
                onChange={handleChange}
            />

            <Form.Input
                label="Количество"
                type="number"
                name="quantity"
                value={data.quantity}
                onChange={handleChange}
            />

            <Form.Input
                label="Продолжительность, мин"
                type="number"
                name="duration"
                value={data.duration}
                step={5}
                onChange={handleChange}
            />

            <UserSelect
                label="Преподаватель"
                name="teacher"
                value={data.teacher}
                options={teachers?.map(teacher => ({
                    key: teacher.id,
                    value: teacher.id,
                    label: teacher.fullname
                }))}
                clearOnBlur
                required
                onChange={handleChange}
            />

            <Form.Select
                label="Формат"
                name="type"
                value={data.type}
                options={lessonTypeOptions}
                onChange={handleChange}
            />

            {data.type === LessonType.Offline && (
                <Form.Select
                    label="Аудитория"
                    name="location"
                    value={data.location}
                    options={lessonLocationsOptions}
                    required
                    onChange={handleChange}
                />
            )}

            <LessonPillGroup
                lessons={lessons}
                readonly
            />
        </Form>
    );
}